import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import IndexHeader from "components/Headers/IndexHeader.js";
import CardBlockProductRating from "../../../components/CardBlockProductRating/CardBlockProductRating";
import { Button } from "reactstrap";
import Swal from 'sweetalert2';
import {
    getProductsRating,
    updateProductsRating,
} from "../../../redux/actions/products_actions";
import { HOST_URL} from "../../../utils/misc.js";
 import NProgress from 'nprogress';

const ProductRating = (props) => {
  // Get OrderId
  const orderId = props.match.params.orderId
  // Check Status Login
  let user = JSON.parse(localStorage.getItem("user"))
  if(!user) {
    props.history.push("/login")
  }
  const [productRating, setProductRating] = useState([])

  useEffect(() => {
    NProgress.start()
    // Scroll To Top
    window.scrollTo(0, 0)

    props.dispatch(getProductsRating(orderId, user.customerId)).then(res => {
        if(res.payload.productRating) {
          // console.log(res.payload.productRating)
          if(res.payload.productRating.length < 1) {
            props.history.push("/login")
          }
          else {
            setProductRating(res.payload.productRating)
          }
        }
    })    
  },[]);

  // props.<combineReducer>.<reducer>.<action>.<property>
  // console.log(props.products.productDetail)

  const handleRating = () => {
    props.dispatch(updateProductsRating(orderId)).then(res =>{
      if(res.payload) {
        if(res.payload.result.success) {
          return(
            Swal.fire({
              title: 'Chân Thành Cảm Ơn',
              text: 'Đánh giá của bạn đã được ghi nhận',
              icon: 'success',
              confirmButtonText: 'Đóng',
              confirmButtonColor: '#000000',
            }
            ).then((ok)=>{
                if(ok){
                  // Clear product rating
                  let productRating = []
                  localStorage.setItem('productRating', JSON.stringify(productRating))
                  //Scroll to top
                  window.scrollTo(0, 0)
                  props.history.push("/home")
                }
            })
          )
        }
      }
      else {
        return(
          Swal.fire({
            title: 'Phiên đăng nhập đã hết hạn!',
            text: 'Vui lòng đăng nhập lại',
            icon: 'warning',
            confirmButtonText: 'Đóng',
            confirmButtonColor: '#000000',
          }
          ).then((ok) => {
              if(ok) {
                props.history.push("/login")
                localStorage.removeItem("user")
              }
          })   
        )        
      }
  })  
  }

  if(productRating.length > 0) {
    NProgress.done()
    return (
      <>
        <div className="container-fluid p-0" style={{ marginBottom: "1%" }}>
          <IndexHeader title="ĐÁNH GIÁ" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_ratingpage} minHeight="500" />
            <div className="container" style={{ background:`linear-gradient(${props.templates.templates.templateProperties.background_product_rating_first}, ${props.templates.templates.templateProperties.background_product_rating_second})`, margin:"0 auto", marginTop:"2%", paddingBottom:"2%", borderRadius:10 }}>
              <div className="justify-content-center" style={{display:'flex'}}>
                <CardBlockProductRating
                list={productRating}
                type="cart"
                title="cart" />
              </div>
              <div className="text-center">
                  <Button className="btn btn-md btn-default btn-round o" onClick={handleRating}><i className="fas fa-vote-yea"></i> Gửi đánh giá cho chúng tôi</Button>
              </div>
            </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="text-center loading">
            <img src={HOST_URL + props.templates.templates.templateProperties.image_loading} style={{width: 150}} />    
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    products: state.products,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(ProductRating);
